import { createFileRoute } from '@tanstack/react-router';
import { CurrenciesPage } from '@/features/currency/currencies-page';

export const Route = createFileRoute('/_app/currencies')({
  component: CurrenciesPage,
});
